import { toString30pk9tzaqopn as toString } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var AuthHookDataClass;
function AuthHookData() {
  if (AuthHookDataClass === VOID) {
    class $ {
      constructor(user, authenticated, loading, error, loginWithRedirect, getIdTokenClaims, logout, getAccessTokenSilently) {
        this.f3s_1 = user;
        this.g3s_1 = authenticated;
        this.h3s_1 = loading;
        this.i3s_1 = error;
        this.j3s_1 = loginWithRedirect;
        this.k3s_1 = getIdTokenClaims;
        this.l3s_1 = logout;
        this.m3s_1 = getAccessTokenSilently;
      }
      af() {
        return this.g3s_1;
      }
      n3s() {
        return this.h3s_1;
      }
      toString() {
        return 'AuthHookData(user=' + toString(this.f3s_1) + ', authenticated=' + this.g3s_1 + ', loading=' + this.h3s_1 + ', error=' + toString(this.i3s_1) + ', loginWithRedirect=' + toString_0(this.j3s_1) + ', getIdTokenClaims=' + toString_0(this.k3s_1) + ', logout=' + toString_0(this.l3s_1) + ', getAccessTokenSilently=' + toString_0(this.m3s_1) + ')';
      }
      hashCode() {
        var result = this.f3s_1 == null ? 0 : hashCode(this.f3s_1);
        result = imul(result, 31) + getBooleanHashCode(this.g3s_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.h3s_1) | 0;
        result = imul(result, 31) + (this.i3s_1 == null ? 0 : hashCode(this.i3s_1)) | 0;
        result = imul(result, 31) + hashCode(this.j3s_1) | 0;
        result = imul(result, 31) + hashCode(this.k3s_1) | 0;
        result = imul(result, 31) + hashCode(this.l3s_1) | 0;
        result = imul(result, 31) + hashCode(this.m3s_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AuthHookData()))
          return false;
        if (!equals(this.f3s_1, other.f3s_1))
          return false;
        if (!(this.g3s_1 === other.g3s_1))
          return false;
        if (!(this.h3s_1 === other.h3s_1))
          return false;
        if (!equals(this.i3s_1, other.i3s_1))
          return false;
        if (!equals(this.j3s_1, other.j3s_1))
          return false;
        if (!equals(this.k3s_1, other.k3s_1))
          return false;
        if (!equals(this.l3s_1, other.l3s_1))
          return false;
        if (!equals(this.m3s_1, other.m3s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'AuthHookData');
    AuthHookDataClass = $;
  }
  return AuthHookDataClass;
}
//region block: exports
export {
  AuthHookData as AuthHookData2x0lxghdz8ao,
};
//endregion

//# sourceMappingURL=AuthHookData.mjs.map
